<template>
  <div>
    <div v-if="showList" class="rightPanel">
      <div v-for="i in invoices.list" class="invoiceBlock" @click="() => openInvoice(i.id)">
        <p><strong>{{ i.id }}</strong></p>
        <p>{{ i.countryName }}</p>
        <p>Препаратов: <strong>{{ i.drugs }}</strong></p>
        <p>На сумму: <strong>{{ i.sum }}</strong> {{ i.currency }}</p>
      </div>
    </div>
  </div>
</template>

<script>

import api from "@/api";

export default {
  data() {
    return {
      showList: false,
      invoices: [],
    }
  },
  watch: {
    '$OrderInvoices': {
      deep: true,
      handler(val) {
        console.log('updated', val);
        if (val.update) {
          this.getInvoiceList();
        }
      }
    }
  },
  computed: {
    $OrderInvoices() {
      return this.$store.getters['invoices/orderInvoices']
    },
    $AllCountries() {
      return this.$store.getters['platform/countries'];
    },
    $AllCurrencies() {
      return this.$store.getters["platform/currencies"];
    },
  },
  created() {
    // this.getInvoiceList()
  },
  methods: {
    openInvoice(id) {
      this.$store.dispatch('invoices/setInvoiceToEdit', {invoiceId: id});
    },
    async getInvoiceList() {
      const {data} = await api.index('/invoices/order')
      if (data.success) {
        const countries = this.$AllCountries.reduce((acc, c) => {
          acc[c.id] = c;
          return acc;
        }, {})
        this.invoices = {
          list: data.records.reduce((acc, i) => {
            const invoice = {
              id: i.id,
              countryName: countries[i.country_id] && countries[i.country_id].name || 'Не указано',
              currency: this.$AllCurrencies[i.currency_id] && this.$AllCurrencies[i.currency_id].currency,
              sum: i.details.reduce((acc, d) => (acc + (d.qty * d.income_price)), 0),
              drugs: i.details.reduce((acc, d) => acc + +d.qty, 0)
            };
            acc.push(invoice);
            return acc;
          }, [])
        };
        this.showList = !!this.invoices.list.length;
      }
    }
  }
}
</script>

<style scoped>
.invoiceBlock {
  padding: 5px;
  cursor: pointer;
  opacity: .7;
  background-color: white;
  border: 1px solid lightgray;
  box-shadow: 1px 4px 5px -1px #000000;
}

.invoiceBlock p {
  margin-bottom: 0;
}

.invoiceBlock:hover {
  opacity: 1;
  background-color: white;
}

.rightPanel {
  position: fixed;
  width: 160px;
  font-size: 14px;
  z-index: 9;
  padding: 5px;
  right: 0;
  top: 120px;
}
</style>
